import { AfterViewInit, ChangeDetectorRef, Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { ActivatedRoute, Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { OperatorShiftService } from '../../../../shared/services/operator-shift.service';
import { NotificationService } from '../../../../core/services/notification.service';
import { MatDialog } from '@angular/material/dialog';
import { IOperatorsOptions } from '../../../../shared/models/interfaces/typology.interface';
import { MatTableDataSource } from '@angular/material/table';
import { catchError, filter, of, switchMap, tap } from 'rxjs';
import { ConfirmDialogComponent } from '../../../../shared/dialog/confirm-modal/confirm-dialog.component';
import { IDeatilOperatorShift } from '../../../../shared/models/interfaces/operator-shift.interface';
import { OperatorShiftUpdateDialogComponent } from '../../dialog/operators-shift-update-dialog/operator-shift-update-dialog.component';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'ngb-detail-operator',
  templateUrl: './detail-operator.component.html',
  styleUrl: './detail-operator.component.scss',
  imports: [
    SharedModule
  ],
})
export class DetailOperatorComponent implements OnInit , AfterViewInit ,OnDestroy {

  //PER TABELLA:
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  displayedColumns: string[] = ['date', 'startShift', 'endShift', 'actions'];
  listOperatorsShift: IDeatilOperatorShift[] = [];
  operator:IOperatorsOptions;
  dataSource = new MatTableDataSource<IDeatilOperatorShift>(this.listOperatorsShift);

  private readonly _operatorShiftService :OperatorShiftService = inject(OperatorShiftService);
  private readonly  _notificationService: NotificationService = inject(NotificationService);
  private readonly dialog: MatDialog = inject(MatDialog);
  private readonly _router: Router = inject(Router);
  private readonly _activateRouter: ActivatedRoute = inject(ActivatedRoute);
  private readonly cdRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  ngOnInit(): void {
    let idOperator:number; 
    this._activateRouter.params.subscribe(params => idOperator = params.id)
    
    this._operatorShiftService.detailOperator(idOperator).pipe(
      tap(operator =>this.operator = operator ),
      switchMap((operator)=> this._operatorShiftService.detailOperatorShift(operator?.id)),
      tap(shifts => {
        this.listOperatorsShift = shifts;
        this.dataSource.data = shifts.map(s => ({
        ...s,
        date: this.convertDateStringToDate(s.shiftDate)
        })); 
      })).subscribe();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource._updateChangeSubscription();
    this.cdRef.detectChanges(); 
  }

  ngOnDestroy(): void {}

  navigate(){
    this._router.navigate(['operator-shifts']);
  }

  convertDateStringToDate(dateStr: string): Date {
    const [year, month, day] = dateStr.split('-');

    return new Date(+year, +month - 1, +day);
  }

  setDate(startDate: string): string {
    const date = new Date(startDate)
    const year = date?.getFullYear();
    const month = (date?.getMonth() + 1).toString().padStart(2, '0');
    const day = date?.getDate().toString().padStart(2, '0');
    return `${day}-${month}-${year}`;
  }

  formatTimeOnly(time: string): string {
    // rimuove i secondi
    return time?.split(':').slice(0, 2).join(':');
  }

  isPastDate(date: string | Date): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // rimuove l'orario per confronto solo di giorno

    const shiftDate = new Date(date);
    shiftDate.setHours(0, 0, 0, 0);

    return shiftDate < today;
  }

  addOperatorShift(){
    this.dialog.open(OperatorShiftUpdateDialogComponent, {
      width: '800px',
      disableClose: true,
      data : {
        operator:this.operator,
        isEdit:false 
      },
    }).afterClosed().pipe(
      filter(res =>!!res),
      switchMap(() =>
        this._operatorShiftService.detailOperatorShift(this.operator.id).pipe(
          tap(shifts => {
          this.listOperatorsShift = shifts;
          this.dataSource.data = shifts; 
          }),
          catchError(err => {
            this.listOperatorsShift = [];
            this.dataSource.data = [];
            return of([]); 
          })
        )
      )
    ).subscribe();
  }

  editOperatorShift(operator:IDeatilOperatorShift){
    this.dialog.open(OperatorShiftUpdateDialogComponent, {
      width: '800px',
      disableClose: true,
      data : {
        operator:this.operator,
        detailShift:operator,
        isEdit:true 
      },
    }).afterClosed().pipe(
      switchMap(() =>
        this._operatorShiftService.detailOperatorShift(this.operator.id).pipe(
          tap(shifts => {
          this.listOperatorsShift = shifts;
          this.dataSource.data = shifts; 
          }),
          catchError(err => {
            this.listOperatorsShift = [];
            this.dataSource.data = [];
            return of([]); 
          })
        )
      )
    ).subscribe();
  }

  deleteOperatorShift(operator:IDeatilOperatorShift){
    this.dialog.open(ConfirmDialogComponent, {
      width: '700px',
      disableClose: true,
      data : {
        title:'Attenzione',
        message : `Sei sicuro di voler procedere con l' eliminazione del seguente turno: Il ${this.setDate(operator.shiftDate)} dalle ${operator.startTime} alle ${operator.endTime}`,
      }, 
    }).afterClosed().pipe(
      filter(res => !!res),
      switchMap(() => this._operatorShiftService.deleteOperatorShift(operator.id)),
      tap(() => this._notificationService.successSnackBar('Il turno è stato eliminato con successo.')),
      switchMap(() =>
        this._operatorShiftService.detailOperatorShift(this.operator.id).pipe(
          tap(shifts => {
          this.listOperatorsShift = shifts;
          this.dataSource.data = shifts; 
          }),
          catchError(err => {
            this.listOperatorsShift = [];
            this.dataSource.data = [];
            return of([]); 
          })
        )
      )
    ).subscribe();
  }

}
